import React, { useEffect } from "react";
import Head from "next/head";
import { useRouter } from "next/router";
import DetailPage from "../../../../components/Blog/DetailPage";
import Articles from "../../../../components/Blog/Articles";
import Link from "next/link";
import Grid from "../../../../components/Blog/Grid";
import Article from "../../../../components/Blog/Articles/Article";
import styles from "./index.module.scss";
import Carousel from "../../../../components/Blog/Carousel";
import { track } from "../../../../utils/amplitude";

export default function Detail(props) {
  const router = useRouter();
  const { meta } = props.article;
  const article = props.article.results;

  const related = meta.related.map((article, i) => (
    <Link href={`/blog/${article.identifier}`} key={i}>
      <a>
        <Article
          color={article.color}
          readingTime={article.reading_time}
          image={article?.icon.thumb}
          title={article.title}
          description={article.pretext}
          avatar={article.user?.avatar.thumb}
          author={`${article.user?.first_name} ${article.user?.last_name} `}
          created={article.published_at || article.created_at}
        />
      </a>
    </Link>
  ));

  const canonical =
    article.locale !== router.query.lang
      ? article.identifier
      : `${router.query.lang}/${article.identifier}`;
  useEffect(() => {
    track("blog_post_opened", {
      article: article.title,
      url: `/blog/${article.identifier}`,
    });
  }, []);

  return (
    <div className={`wrapper ${styles.container}`}>
      <Head>
        <title>{article.meta_title || article.title} - Apphud</title>
        <link rel="canonical" href={`https://apphud.com/blog/${canonical}`} />
        <meta charSet="utf-8" />
        <meta name="description" content={article.meta_description} />
        <meta name="keywords" content={article.meta_keywords} />
        <meta
          property="og:title"
          content={article.meta_title || article.title}
        />
        <meta
          property="og:image"
          content={
            article.og_cover_url ||
            article.featured_image.original ||
            article.icon.original
          }
        />
        <meta
          property="og:image:url"
          content={
            article.og_cover_url ||
            article.featured_image.original ||
            article.icon.original
          }
        />
        <meta
          property="og:description"
          content={article.og_description || article.pretext}
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={props.url} />
        {props.meta_locales.map((el, key) => (
          <link
            key={key}
            rel="alternate"
            hrefLang={key === 0 ? "x-default" : el.locale}
            href={el.url}
          />
        ))}
      </Head>
      <DetailPage article={article} />
      {meta.related.length > 0 && (
        <>
          <Articles>
            <div className="container">
              <h2 style={{ marginBottom: 44, marginTop: 24 }}>Related Posts</h2>
              <div className={styles.isDesktop}>
                <Grid>{related}</Grid>
              </div>
              <div className={styles.isMobile}>
                <Carousel data={related} />
              </div>
            </div>
          </Articles>
        </>
      )}
    </div>
  );
}

export async function getServerSideProps(context) {
  const { query, req, resolvedUrl, params } = context;
  const res = await fetch(
    `https://api.apphud.com/blog/posts/${query.slug}?locale=${query.lang}`
  );
  try {
    const article = await res.json();
    const locales = article.results.locales
      .concat([article.results.locale])
      .sort();
    return {
      props: {
        query: query,
        article,
        meta_locales: locales.map((locale) => ({
          locale,
          url: `https://${
            req.headers.host +
            resolvedUrl.replace(
              `/${params.lang}`,
              locale === "en" ? "" : `/${locale}`
            )
          }`,
        })),
        url: `https://${req.headers.host + resolvedUrl}`,
      },
    };
  } catch (e) {
    return {
      redirect: {
        destination: "/404",
        permanent: false,
      },
    };
  }
}
